<script setup lang="ts">
import { Activity } from '@/components/activity/';
</script>

<template>
    <div class="activity-container">
        <Activity />
    </div>
</template>

<style scoped lang="scss">
.activity-container {
    height: 100%;
}
</style>
